export const DOCUMENT_FORM = {
  CREATE: 'CREATE',
  EDIT: 'EDIT',
}



// WEBPACK FOOTER //
// ./src/Containers/Settings/Documentation/constants.js